//extracted by mini-css-extract-plugin
export default {"container":"styles_container__OkrEf","dot":"styles_dot__IpC5q","dotActive":"styles_dotActive__9GylJ"};;